import Parserror from 'parserror';

const errorParser = Parserror
.new()
.addCases([
  /**
   * Catches case where there is no job or file corresponding to the customer id.
   */
  {
    name: 'missingFileOrJobForCustomerId',
    condition: /No data found for customer .*? and (?:job_execution|filename) .*?\./i,
    message: () => 'There was an error loading the job, please try again or contact support',
  },
  /**
   * Catches case where the customer doesn't have any jobs that are getting executed.
   */
  {
    name: 'noActiveJobForCustomerIdAndFilename',
    condition: /No active job execution found for customer .*? and filename .*?\./i,
    message: () => 'No running job was found for this customer',
  },
  /**
   * Catches case where there is an active job getting executed for the customer.
   */
  {
    name: 'jobAlreadyRunning',
    condition: /There is a job execution in status running for the customer .*?$/,
    message: () => 'The customer account is already executing a job',
  },
  /**
   * Catches case where a customer account does not have variants.
   */
  {
    name: 'missingSettingForAccount',
    condition: /No entity of type \[settings\] was found using \[.*?\]\./i,
    message: () => 'This customer account doesn\'t have variants',
  },
  /**
   * Catches case where the parameter is missing.
   */
  {
    name: 'missingParameter',
    condition: /The parameter \"(.*?)\" is missing\./i,
    message: (parameter) => `The parameter "${parameter}" is required`,
  },
])
.allowOriginals([
  /The requested log doesn't exist/i,
  /The job configured for variant .*? is not valid\./i,
  /The variant .*? does not have an import job configured or is not valid\./i,
  /The parameter \".*?\" received an invalid (?:type|value) \".*?\", expected was \".*?\"\./i,
]);

export { errorParser };
